import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-mataccordion',
	templateUrl:'./MatAccordionPage.html',
	styles: [],
	styleUrls:['./MatAccordionPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatAccordionPage
{
	mdContent_234 = `\`\`\`java
import com.jwebmp.plugins.angular.material.accordion.MatAccordion;
\`\`\``;
	mdContent_235 = `\`\`\`java
MatAccordion()
\`\`\``;
	mdContent_236 = `\`\`\`java
MatAccordion&lt;?&gt; acc = new MatAccordion&lt;&gt;();
acc.setMulti(true);
acc.addPanel("Section 1", new DivSimple&lt;&gt;().setText("Content 1"));
acc.addPanel("Section 2", new DivSimple&lt;&gt;().setText("Content 2"));
\`\`\``;
}
